export default [
  {
    id: '98cacf7e-c6df-4383-b734-3729485016b8', // id 全局唯一，终身制
    path: '/wiz-tag-3d-position-management-vulkan',
    name: 'wizTag3dPositionManagement',
    meta: { title: '点位设置(5.0)' },
    // layout: 'default',
    // 根菜单不需要定义 component，由主框架定义
    children: [
      {
        id: '68c56214-1182-4a77-8048-ae49d84b9749', // id 全局唯一，终身制
        path: 'position-setting',
        name: 'positionSetting',
        meta: { title: '设备点位设置' },
        children: [
          {
            id: '2ef1eb06-a78a-4119-bdde-e115fc939a83',
            path: 'position-setting',
            name: 'positionSetting',
            component: () => {
              return import('./views/tag3dPosition/monitor-location-setting/index')
            },
            meta: {
              title: '点位设置',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
        ],
      },
    ],
  },
]
